<template>
    <Header></Header>
    <div class="container sub_page _activity">
        <section class="sub_page_tit">
            <div class="deco_wrap">
                <i class="deco_01"><img src="img/activity_left.png" /></i>
                <i class="deco_02 _small blink4"><img src="img/b_icon_01.png" /></i>
                <i class="deco_03 _small blink_zoom1"><img src="img/b_icon_02.png" /></i>
                <i class="deco_04 _xxsmall blink_zoom4"><img src="img/b_icon_05.png" /></i>
                <i class="deco_05 none_768 spin2 _medium"><img src="img/b_icon_03.png" /></i>
                <i class="deco_06 none_768 spin_blink3 _small"><img src="img/b_icon_01.png" /></i>
                <i class="deco_07 none_768 blink_zoom4 _small"><img src="img/b_icon_02.png" /></i>
                <i class="deco_character"><img src="img/activity_icon.png" /></i>
            </div>
            <div class="banner_wrap wrap_1120">
                <h2>시민참여 활동</h2>
            </div>
            <div class="sub_menu_tab wrap_1120">
                <button class="only_768" @click="subMenuTab" :class="{ active: state.subMenuOpen }">{{ state.subMenuName }}</button>
                <ul :class="{ active: state.subMenuOpen }">
                    <li @click="changeTab(1)" :class="[state.tab === 1 ? 'active' : '']"><a href="javascript:void(0)">반성매매 시민활동</a></li>
                    <li @click="changeTab(2)" :class="[state.tab === 2 ? 'active' : '']"><a href="javascript:void(0)">캠페인·이벤트</a></li>
                    <li @click="changeTab(3)" :class="[state.tab === 3 ? 'active' : '']">
                        <a href="javascript:void(0)">참여하고 싶은 반성매매 활동 제안</a>
                    </li>
                    <li v-if="user.isLogin()" @click="changeTab(4)" :class="[state.tab === 4 ? 'active' : '']" class="w_1024_custom_width">
                        <a href="javascript:void(0)">액션 시민 활동</a>
                    </li>
                </ul>
            </div>
        </section>

        <section class="sub_page_con wrap_1120">
            <div class="bread_crumbs">
                <router-link to="/" class="icon_wrap"><img src="img/home_icon.png" alt="홈" /></router-link>
                <!-- 
                <span class="icon_wrap"><img src="img/part_icon.png" alt="시민참여 활동" /></span>
                <a href="javascript:void(0)">시민참여 활동</a>
                 -->
                <span class="icon_wrap"><img src="img/part_icon.png" alt="반성매매 시민활동" /></span>
                <router-link :to="{ path: '/board', query: { type: 1 } }">반성매매 시민활동</router-link>
                <span class="icon_wrap"><img src="img/part_icon.png" :alt="state.data.title" /></span>
                <a href="javascript:void(0)" style="cursor: default">{{ state.data.title }}</a>
            </div>
            <div class="sub_page_con_view con_view">
                <div class="tit_wrap flex_wrap">
                    <span class="con_tit">
                        <span :class="{ d_day_hour: CommonUtils.getDDayHour(new Date(state.data.recruitEndDate)) }">
                            {{ CommonUtils.getDDayHour(new Date(state.data.recruitEndDate)) }}
                        </span>
                        {{ state.data.title }}
                    </span>
                    <span class=""></span>
                    <div class="con_tit_info">
                        <span class="">{{ CommonUtils.dateFormat(new Date(state.data.createDate), ".", true) }}</span>

                        <span><img src="img/view.png" alt="" /></span>
                        {{ state.data.viewCnt ? CommonUtils.numberFormat(state.data.viewCnt) : "" }}

                        <span class="writer_info">
                            <span>작성자</span>
                            {{ state.data.writer }}
                        </span>
                    </div>
                </div>
                <div class="con_info_wrap">
                    <div v-if="state.data.activeStartDate && state.data.activeEndDate">
                        <span class="info_tit">
                            <img src="img/info_icon_01.png" alt="활동기간" />
                            활동기간
                        </span>
                        <span class="info_desc">
                            {{
                                CommonUtils.dateFormat(new Date(state.data.activeStartDate), ".", false) +
                                "-" +
                                CommonUtils.dateFormat(new Date(state.data.activeEndDate), ".", false)
                            }}
                        </span>
                    </div>
                    <div v-if="state.data.recruitStartDate && state.data.recruitEndDate">
                        <span class="info_tit">
                            <img src="img/info_icon_02.png" alt="모집기간" />
                            모집기간
                        </span>
                        <span class="info_desc">
                            {{
                                CommonUtils.dateFormat(new Date(state.data.recruitStartDate), ".", false) +
                                "-" +
                                CommonUtils.dateFormat(new Date(state.data.recruitEndDate), ".", false)
                            }}
                        </span>
                    </div>
                    <div v-if="state.data.applyDate">
                        <span class="info_tit">
                            <img src="img/info_icon_02.png" alt="신청 마감" />
                            신청 마감
                        </span>
                        <span class="info_desc">
                            {{ CommonUtils.dateFormat(new Date(state.data.applyDate), ".", false) }}
                        </span>
                    </div>
                    <div v-if="state.data.cntApply > 0">
                        <span class="info_tit">
                            <img src="img/info_icon_03.png" alt="모집인원" />
                            모집인원
                        </span>
                        <span class="info_desc">{{ CommonUtils.numberFormat(state.data.cntApply) }}명</span>
                    </div>
                    <div>
                        <span class="info_tit">
                            <img src="img/info_icon_04.png" alt="장소" />
                            장소
                        </span>
                        <span class="info_desc">{{ state.data.address }} {{ state.data.addressDetail }}</span>
                    </div>
                </div>
                <div class="">
                    <div class="content" v-html="CommonUtils.decodeContent(state.data.content)"></div>

                    <div class="file_list_wrap _column" v-if="state.data.fileList != null && state.data.fileList.length > 0">
                        <div v-for="item in state.data.fileList" :key="item.idx">
                            <button type="button" @click="downloadFile(item.file, item.imgRealName)">
                                <span class="file_name">{{ item.imgRealName }}</span>
                                <img src="img/download.png" alt="" />
                            </button>
                        </div>
                    </div>

                    <div class="apply_wrap btn_wrap _default _center" v-if="!state.hasAuth">
                        <template v-if="state.data.state === 2">
                            <button v-if="!state.data.isApply" class="common_btn w_130" @click="apply">신청하기</button>
                            <button v-else class="common_btn w_130 _gray" disabled>이미 신청</button>
                        </template>
                        <button class="common_btn _gray w_130" @click="router.push('/board?type=1')">목록</button>
                    </div>
                    <!--관리자 버튼-->
                    <div class="apply_wrap btn_wrap _default right_btn" v-if="state.hasAuth">
                        <button class="common_btn _gray" type="button" @click="confirmRemove">삭제</button>
                        <button class="common_btn" type="button" @click="router.push({ name: 'ActivityModify', params: { id: state.idx } })">
                            수정
                        </button>
                        <template v-if="state.data.state === 2 || state.data.state === 3">
                            <button class="common_btn" type="button" @click="showModalForApply" v-if="!state.isMobile">신청인원</button>
                        </template>
                        <button class="common_btn" type="button" @click="router.push('/board?type=1')">목록</button>
                    </div>
                    <!--관리자 버튼-->
                </div>
            </div>
            <div class="list_wrap">
                <router-link v-if="state.data.next" :to="{ name: 'ActivityView', params: { id: state.data.next.idx } }" class="next_list">
                    <span>다음글</span>
                    <div class="list_tit elips_1">
                        {{ state.data.next.title }}
                    </div>
                    <div class="list_date" v-if="!state.isMobile">{{ CommonUtils.dateFormat(new Date(state.data.next.createDate), ".", true) }}</div>
                    <div class="list_date" v-else>{{ CommonUtils.dateFormatForMobile(new Date(state.data.next.createDate), ".", true) }}</div>
                </router-link>

                <router-link v-if="state.data.prev" :to="{ name: 'ActivityView', params: { id: state.data.prev.idx } }" class="prev_list">
                    <span>이전글</span>
                    <div class="list_tit elips_1">{{ state.data.prev.title }}</div>
                    <div class="list_date" v-if="!state.isMobile">{{ CommonUtils.dateFormat(new Date(state.data.prev.createDate), ".", true) }}</div>
                    <div class="list_date" v-else>{{ CommonUtils.dateFormatForMobile(new Date(state.data.prev.createDate), ".", true) }}</div>
                </router-link>
            </div>
        </section>
    </div>
    <PaperModal v-if="state.isShowApply" :list="state.listForm" @close="state.isShowApply = false" @save="receiveAnswer"></PaperModal>
    <ModalApplicantCheck
        v-if="state.isShowModalForApply"
        :idx="state.idx"
        :data="state.data"
        @close="state.isShowModalForApply = false"
        @save="saveMemo"
    ></ModalApplicantCheck>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        :isPossible="true"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
    <ModalTermsForBoard
        v-if="state.data.term && state.isShowModalForTerms"
        :content="CommonUtils.decodeContent(state.data.term)"
        @close="closeTerms"
    ></ModalTermsForBoard>
    <Sign :config="config" @saved="handleSave" @close="closeSignModal" />
    <Footer></Footer>
</template>

<script lang="ts" config>
    import {
        reactive,
        globalStore,
        onMounted,
        watch,
        router,
        Header,
        Footer,
        types,
        apiService,
        useRoute,
        userStore,
        CommonUtils,
        PaperModal,
        ModalDefault,
        ModalApplicantCheck,
        Sign,
        onBeforeMount,
        getMessageByCode,
        ModalTermsForBoard,
    } from "@/BaseComponent";

    export default {
        components: { Header, Footer, ModalDefault, Sign, ModalApplicantCheck, PaperModal, ModalTermsForBoard },
        setup() {
            const route = useRoute();
            const global = globalStore();
            const user = userStore();
            const state = reactive({
                tab: 1 as number,
                idx: 0 as number,

                data: {} as types.ResBoardVOForApi,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                hasAuth: false as boolean,

                isShowModalForApply: false as boolean,
                isShowModalForTerms: false as boolean,

                subMenuOpen: false,
                subMenuName: "반성매매 시민활동" as string,

                isMobile: false,

                listForm: [] as Array<types.BoardApplyFormVOForApi>,
                isShowApply: false as boolean,
                answerData: [] as Array<any>,
            });

            const form_state = reactive({
                interest: "" as string,
                apply: "" as string,
                file: "" as any,
            });

            const config = reactive({
                visible: false,
                width: 600,
                height: 400,
                penColor: "black",
                backgroundColor: "white",
            });

            onBeforeMount(() => {
                hasAuth();
            });

            onMounted(() => {
                const idx = Number(route.params.id);

                if (idx && typeof idx === "number" && !isNaN(idx)) {
                    state.idx = idx;
                    getDetail();
                } else {
                    router.back();
                }

                state.isMobile = window.innerWidth < 768;
            });

            watch(
                () => route.params.id,
                () => {
                    const idx = Number(route.params.id);
                    state.idx = idx;
                    getDetail();
                },
            );

            watch(
                () => [user.userInfo, user.accessToken],
                () => {
                    hasAuth();
                    getDetail();
                },
            );

            const hasAuth = () => {
                if (
                    user.isLogin() &&
                    (user.userInfo.gubun === 1 ||
                        (user.userInfo.isAdmin && user.roles != null && user.roles.some((item: types.RoleVO) => item.key.indexOf("ad") > -1)))
                )
                    state.hasAuth = true;
            };

            const changeTab = (tab: number) => {
                global.setBoardTab(tab);
                router.push("/board?type=" + tab);
                state.subMenuOpen = false;
                switch (tab) {
                    case 1:
                        state.subMenuName = "반성매매 시민활동";
                        break;
                    case 2:
                        state.subMenuName = "캠페인·이벤트";
                        break;
                    case 3:
                        state.subMenuName = "참여하고 싶은 반성매매 활동 제안";
                        break;
                }
            };

            const subMenuTab = () => {
                if (window.innerWidth <= 768) {
                    state.subMenuOpen = !state.subMenuOpen;
                }
            };

            const getDetail = async () => {
                const res = await apiService.boardActivity.detail(state.idx);

                if (res.returnCode === 0) {
                    state.data = res.data;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const closeSignModal = () => {
                config.visible = false;
            };

            const closeModal = () => {
                state.isShowModal = false;
                if (state.modalTab === 8) router.back();
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    removeData();
                } else if (param.action === "callback") {
                    state.isShowModal = false;
                    router.replace({ path: "/login", query: { redirect: "/activityView/" + state.idx } });
                } else if (param.action === "back") {
                    state.isShowModal = false;
                    router.back();
                }
            };

            const apply = () => {
                if (!(user && user.accessToken)) {
                    state.isShowModal = true;
                    state.modalTab = 7;
                    state.modalTitle = "알림";
                    state.modalContent = "로그인을 진행해주세요.";
                } else {
                    getList();

                    // state.isShowModal = true;
                    // state.modalTab = 6;
                    // state.modalTitle = "알림";
                    // state.modalContent = "지원 동기를 작성해주세요.";
                }
            };

            const receiveAnswer = (param: any) => {
                state.answerData = param;

                state.isShowApply = false;
                if (state.data.term) state.isShowModalForTerms = true;
                else {
                    form_state.apply = "";
                    form_state.interest = "";
                    config.visible = true;
                }
            };

            const getList = async () => {
                state.listForm = [];

                const res = await apiService.boardActivity.getFormList(state.idx);
                if (res.returnCode === 0) {
                    state.listForm = res.data;
                    state.answerData = [];
                    state.isShowApply = true;
                } else if (res.returnCode === 29) {
                    state.listForm = [];
                    state.answerData = [];

                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "신청 양식이 준비되지 않았습니다.";
                    state.isShowModal = true;
                } else {
                    state.listForm = [];
                    state.answerData = [];

                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const applyInsert = async () => {
                const param: types.ReqBoardApply = {
                    interest: "",
                    apply: "",
                    file: form_state.file,
                    answers: JSON.stringify(state.answerData),
                };
                const res = await apiService.boardActivity.apply(state.idx, param);
                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.isShowModal = true;
                    state.modalTitle = "안내";
                    state.modalContent = "신청이 완료되었습니다.";
                    getDetail();
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }

                state.answerData = [];
            };

            // 저장 이벤트 수신
            const handleSave = async ({ dataUrl, file }: any) => {
                form_state.file = file;
                // downloadFile(file);

                await applyInsert();
                config.visible = false;
            };

            const downloadFile = async (fileUrl: string, fileName: string) => {
                const res = await fetch(fileUrl);
                const blob = await res.blob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);
            };

            const removeData = async () => {
                const res = await apiService.boardActivity.remove(state.idx);

                if (res.returnCode === 0) {
                    state.modalTab = 8;
                    state.isShowModal = true;
                    state.modalTitle = "안내";
                    state.modalContent = getMessageByCode(res.returnCode);
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const confirmRemove = () => {
                if (user.isLogin()) {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                }
            };

            const showModalForApply = () => {
                state.isShowModalForApply = true;
            };

            const saveMemo = async (memo: string) => {
                const param: types.ReqBoardForActivityForModify = {
                    title: null,
                    content: null,
                    term: null,
                    activityStartDate: null,
                    activityEndDate: null,
                    recruitmentStartDate: null,
                    recruitmentEndDate: null,
                    endDate: null,
                    cntMember: null,
                    zipCode: null,
                    address: null,
                    addressDetail: null,
                    file: null,
                    memo: state.data.memo,
                };

                const res = await apiService.boardActivity.modify(state.idx, param);

                if (res.returnCode === 0) {
                    getDetail();
                    state.isShowModalForApply = false;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const closeTerms = (result: boolean) => {
                state.isShowModalForTerms = false;
                if (result) {
                    form_state.apply = "";
                    form_state.interest = "";
                    config.visible = true;
                }
            };

            return {
                state,
                router,
                user,
                changeTab,
                subMenuTab,
                closeModal,
                callBackModal,
                downloadFile,
                CommonUtils,
                apply,
                config,
                handleSave,
                closeSignModal,
                form_state,
                removeData,
                confirmRemove,
                showModalForApply,
                saveMemo,
                receiveAnswer,
                closeTerms,
            };
        },
    };
</script>

<style scoped>
    .tit_wrap img {
        vertical-align: unset;
    }
    .list_wrap a[class*="_list"]:nth-child(2) {
        border-top: 1px solid #c4c4c4;
    }

    .list_wrap a[class*="_list"] {
        display: flex;
        gap: 10px;
        padding: 10px 0;
        position: relative;
        cursor: pointer;
    }

    .list_wrap a[class*="_list"]:hover {
        background-color: #fafafa;
    }

    .list_wrap a[class*="_list"] span {
        background-color: #fff9e9;
        padding: 3px 10px;
        color: #ff8935;
        font-weight: 500;
        font-size: 14px;
    }
    .d_day_hour {
        display: inline-block;
        background-color: #f90303;
        color: white;
        font-size: 15px;
        padding: 2px 6px;
        font-weight: 700;
        border-radius: 3px;
        margin-bottom: 7px;

        margin-top: 2px;
        margin-right: 5px;
    }
</style>
